export default __webpack_public_path__ + "static/media/addFile.a1124bee.svg";